import type { FunctionComponent } from "react";

import iconJson from "./icon-listening-final.json";
import {
  IconContainer,
  StyledIconHeadphoneSvg,
  StyledIconSpinnerSvg,
  StyledPlayer,
} from "./styles";

type Props = {
  isLoading: boolean;
  isPaused: boolean;
  isPlayed: boolean;
};
export const HeadphoneIcon: FunctionComponent<Props> = ({ isLoading, isPaused, isPlayed }) => {
  if (isLoading) {
    return <StyledIconSpinnerSvg />;
  }

  if (isPlayed) {
    return <StyledPlayer src={iconJson} autoplay loop />;
  }

  if (isPaused) {
    return (
      <IconContainer $isGreyed={true}>
        <StyledIconHeadphoneSvg />
      </IconContainer>
    );
  }

  return (
    <IconContainer>
      <StyledIconHeadphoneSvg />
    </IconContainer>
  );
};

HeadphoneIcon.displayName = "HeadphoneIcon";
